<template>
    <div class="user_body">
        <div style="display: flex;justify-content: flex-end;align-items: center;">
            <span style="font-size: 16px;color: #fff;margin-right: 10px;">欢迎您，{{username}}</span>
            <el-button type="text" style="color: #fff;font-size: 16px" @click="outsys"><i class="el-icon-switch-button"></i><span>退出登录</span></el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Userinfo",
        data(){
            return{
                username: localStorage.getItem('username')
            }
        },
        methods:{
            outsys(){
                this.$router.push('/');
                localStorage.removeItem('JSESSIONID')
                localStorage.removeItem('username')
            }
        }
    }
</script>

<style scoped>
    .user_body {

    }
</style>
